import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ladipage',
  templateUrl: './ladipage.component.html',
  styleUrls: ['./ladipage.component.scss']
})
export class LadipageComponent implements OnInit {
  loading = false;
  
  constructor() {}

  ngOnInit(): void {
    this.loading = true
  }

}
